import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import { Common } from "@/helper/common";

Vue.use(Vuex);
let sourceSite = "SCE_ApplyOnline";
let referralSource = "501";
let referredBy = "0";
let referredByEmpId = "0";
let gaTracking = "";
let email = "";
let firstname = "";
let lastname = "";
//source - we don't care about coookie for sourceSite
if (Common.getQuerystring("source") != "") {
  sourceSite = sourceSite + "_" + Common.getQuerystring("source");
  Common.setCookie("source", sourceSite, 30);
} else if (Common.getCookie("source") != null)
  sourceSite = sourceSite + "_" + Common.getCookie("source");

//referralSource
if (Common.getQuerystring("refSrc") != "") {
  referralSource = Common.getQuerystring("refSrc");
  Common.setCookie("refSrc", referralSource, 30);
} else if (Common.getCookie("refSrc") != null)
  referralSource = Common.getCookie("refSrc");

//referredBy
if (Common.getQuerystring("refBy") != "") {
  referredBy = Common.getQuerystring("refBy");
  Common.setCookie("refBy", referredBy, 30);
} else if (Common.getCookie("refBy") != null)
  referredBy = Common.getCookie("refBy");

//referredByEmployee
if (Common.getQuerystring("emp") != "") {
  referredByEmpId = Common.getQuerystring("emp");
  Common.setCookie("emp", referredByEmpId, 30);
} else if (Common.getCookie("emp") != null)
  referredByEmpId = Common.getCookie("emp");

//ga tracking
if (
  Common.getQuerystring("utm_source") != "" &&
  Common.getQuerystring("utm_source") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_source = " +
    Common.getQuerystring("utm_source");
  Common.setCookie("utm_source", Common.getQuerystring("utm_source"), 30);
} else if (
  Common.getCookie("utm_source") != null &&
  Common.getCookie("utm_source") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_source = " +
    Common.getCookie("utm_source");

if (
  Common.getQuerystring("utm_medium") != "" &&
  Common.getQuerystring("utm_medium") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_medium = " +
    Common.getQuerystring("utm_medium");
  Common.setCookie("utm_medium", Common.getQuerystring("utm_medium"), 30);
} else if (
  Common.getCookie("utm_medium") != null &&
  Common.getCookie("utm_medium") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_medium = " +
    Common.getCookie("utm_medium");

if (
  Common.getQuerystring("utm_content") != "" &&
  Common.getQuerystring("utm_content") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_content = " +
    Common.getQuerystring("utm_content");
  Common.setCookie("utm_content", Common.getQuerystring("utm_content"), 30);
} else if (
  Common.getCookie("utm_content") != null &&
  Common.getCookie("utm_content") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_content = " +
    Common.getCookie("utm_content");

if (
  Common.getQuerystring("utm_term") != "" &&
  Common.getQuerystring("utm_term") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_term = " +
    Common.getQuerystring("utm_term");
  Common.setCookie("utm_term", Common.getQuerystring("utm_term"), 30);
} else if (
  Common.getCookie("utm_term") != null &&
  Common.getCookie("utm_term") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_term = " +
    Common.getCookie("utm_term");

if (
  Common.getQuerystring("utm_campaign") != "" &&
  Common.getQuerystring("utm_campaign") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_campaign = " +
    Common.getQuerystring("utm_campaign");
  Common.setCookie("utm_campaign", Common.getQuerystring("utm_campaign"), 30);
} else if (
  Common.getCookie("utm_campaign") != null &&
  Common.getCookie("utm_campaign") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_campaign = " +
    Common.getCookie("utm_campaign");

if (
  Common.getQuerystring("GCLID") != "" &&
  Common.getQuerystring("GCLID") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "GCLID = " +
    decodeURIComponent(Common.getQuerystring("GCLID"));
  Common.setCookie("GCLID", Common.getQuerystring("GCLID"), 30);
} else if (Common.getCookie("GCLID") != null && Common.getCookie("GCLID") != "")
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "GCLID = " +
    decodeURIComponent(Common.getCookie("GCLID"));

    //pre fill email, first/lastname
if (Common.getCookie("email") != null) email = Common.getCookie("email");
if (Common.getCookie("firstname") != null)
  firstname = Common.getCookie("firstname");
if (Common.getCookie("lastname") != null)
  lastname = Common.getCookie("lastname");

export default new Vuex.Store({
  state: {
    tabs: [
      {
        name: "Account",
        icon: "ti-user",
        isActive: true,
      },
      {
        name: "Preferences",
        icon: "ti-star",
        isActive: false,
      },
      {
        name: "Details",
        icon: "ti-email",
        isActive: false,
      },
      {
        name: "Identity",
        icon: "ti-id-badge",
        isActive: false,
      },
      
    ],
    currentActive: 0,
    totalTabs: 0,
    form: {
      title: "",
      firstName: firstname,
      lastName: lastname,
      email: email,
      dob: "",
      addressLine: "",
      postCode: "",
      buildingNo: "",
      city: "",
      country: {
          CountryId: 225,
          CountryName: "UNITED KINGDOM",
          ShowOnSite: true,
          TwoCharCode: "GB",
        },
      postcodeAnywhereId:"",
      street:"",
      district:"",
      countyState:"",
      useDetails:false,
      telPrefix: "",
      telephone: "",
      mobilePrefix: "",
      mobile: "",
      titleAdditional: "",
      firstNameAdditional: "",
      lastNameAdditional: "",
      emailAdditional: "",
      dobAdditional: "",
      addressLineAdditional: "",
      postCodeAdditional: "",
      buildingNoAdditional: "",
      cityAdditional: "",
      countryAdditional: {
        CountryId: 225,
        CountryName: "UNITED KINGDOM",
        ShowOnSite: true,
        TwoCharCode: "GB",
      },
      postcodeAnywhereIdAdditional:"",
      streetAdditional:"",
      districtAdditional:"",
      countyStateAdditional:"",
      useDetailsAdditional:false,
      mobilePrefixAdditional: "",
      mobileAdditional: "",
      sourceCurrency: "",
      targetCurrency: "",
      transferAmount: "",
      transferDestination: "",
      reasonForTransfer: "",
      terms: false,
      jointAccount:"no",
      sameAddressAsMain:true,
      sourceSite: sourceSite,
      sourceSiteForPreference: "SCE_ApplyOnline_PREF",
      referralSource: referralSource,
      referredBy: referredBy,
      referredByEmpId: referredByEmpId,
      referredByEmail: "",
      gaTracking: gaTracking,
      bizId: 22,
      clientType: "PC",
      isContactExist: false,
      isPrivateClient:true,
      twoFaMessage:'',
      antiSpam: (sourceSite=="SCE_ApplyOnline")?true:false,
      showCallback: false,

    },
    userIdentities:[],
    actions: {
      showMobileVerification: false,
      isFInalStep: false,
      hasOTPAccess: false,
      skippedMobileVerification: false,
      isMobileVerified: false,
      isGBGVerified: false,
      hideNavigation: false,
    },
    messageInfo: {
      show: false,
      message: "",
      isSuccess: false,
    },
    countries: [],
    countryCodes: [],
    currencies: [],
    rfts: [],
    // contactId: 744936,
    // additionalContactId:822379,
    contactId: null,
    mainContactId:null,
    additionalContactId:null,
    jwtToken:null,
    mainUserGBGStatus:"",
    additionalUserGBGStatus:""
  },
  getters: {
    getField,
    getTabs: (state) => {
      return state.tabs;
    },
    getCurrentActive: (state) => {
      return state.currentActive;
    },
    getTotalTabs: (state) => {
      return state.totalTabs;
    },
    getActions: (state) => {
      return state.actions;
    },
    getFormData: (state) => {
      return state.form;
    },
    getUserIdentities:(state)=>{
      return state.userIdentities;
    },
    getMessageInfo: (state) => {
      return state.messageInfo;
    },
    getCountries: (state) => {
      return state.countries;
    },
    getCountryCodes: (state) => {
      return state.countryCodes;
    },
    getCurrencies: (state) => {
      return state.currencies;
    },
    getRfts: (state) => {
      return state.rfts;
    },
    getContactId: (state) => {
      return state.contactId;
    },
    getMainContactId: (state) => {
      return state.mainContactId;
    },
    getAdditionalContactId: (state) => {
      return state.additionalContactId;
    },
    getJwtToken:(state)=>{
      return state.jwtToken;
    },
    getMainUserGBGStatus:(state)=>{
      return state.mainUserGBGStatus;
    },
    getAdditionalUserGBGStatus:(state)=>{
      return state.additionalUserGBGStatus;
    },
    isMainUserGBGVerified:(state)=>{
      let isAlreadyVerified=false;
      if (state.mainUserGBGStatus!="")
      {
       if (state.mainUserGBGStatus == "verified" || state.mainUserGBGStatus == "invalid")
        isAlreadyVerified= true;
      }
      return isAlreadyVerified;
    },
    isAdditionalUserGBGVerified:(state)=>{
      let isAlreadyVerified=false;
      if (state.additionalUserGBGStatus!="")
      {
       if (state.additionalUserGBGStatus == "verified" || state.additionalUserGBGStatus == "invalid")
        isAlreadyVerified= true;
      }
      return isAlreadyVerified;
    },
    getAntiSpam:(state)=>{
      return state.form.antiSpam;
    },
    getCallback: (state) => {
      return state.form.showCallback;
    }
  },
  mutations: {
    updateField,
    setTabs: (state, payload) => {
      state.tabs = payload;
    },
    setCurrentActive: (state, payload) => {
      state.currentActive = payload;
    },
    setTotalTabs: (state, payload) => {
      state.totalTabs = payload;
    },
    showHideMobileVerification: (state, payload) => {
      state.actions.showMobileVerification = payload.show;
      if (payload.message && payload.message.indexOf('ending in')>-1)
        state.form.twoFaMessage=payload.message.substr(payload.message.indexOf('ending in')+9);
      else if (process.env.VUE_APP_API_URL.indexOf('onboardingapidev')>-1 && payload.message && payload.message.indexOf('Code:')>-1)
      {
        state.form.twoFaMessage='On-screen '+payload.message.substr(payload.message.indexOf('Code:'));
      }
    },
    twoFaMessage:(state,payload)=>{
      state.form.twoFaMessage=payload;
      if (payload.indexOf('ending in')>-1)
      state.form.twoFaMessage=payload.substr(payload.indexOf('ending in')+9);
    else if (process.env.VUE_APP_API_URL.indexOf('onboardingapidev')>-1 && payload.indexOf('Code:')>-1)
    {
      state.form.twoFaMessage='On-screen '+payload.substr(payload.indexOf('Code:'));
    }
    },
    setFinalStep: (state, payload) => {
      state.actions.isFInalStep = payload;
    },
    setMessageInfo: (state, payload) => {
      state.messageInfo = payload;
    },
    setCountries: (state, payload) => {
      state.countries = payload;
    },
    setCountryCodes: (state, payload) => {
      state.countryCodes = payload;
    },
    setCurrencies: (state, payload) => {
      state.currencies = payload;
    },
    setRfts: (state, payload) => {
      state.rfts = payload;
    },
    setContactId: (state, payload) => {
      state.contactId = payload;
    },
    setMainContactId: (state, payload) => {
      state.mainContactId = payload;
    },
    setAdditionalContactId: (state, payload) => {
      state.additionalContactId = payload;
    },
    setContactExist: (state, payload) => {
      state.form.isContactExist = payload;
    },
    setHideNavigation: (state, payload) => {
      state.actions.hideNavigation = payload;
    },
    setMobileVerified: (state, payload) => {
      state.actions.isMobileVerified = payload;
    },
    setGBGVerified: (state, payload) => {
      state.actions.isGBGVerified = payload;
    },
    isPrivateClient: (state, payload) => {
      state.form.isPrivateClient = payload;
    },
    addUserIdentity(state,payload) {
      if (state.userIdentities.length)
      {
        let foundIndex = state.userIdentities.findIndex(el=> el.contactId==payload.contactId);
        if (foundIndex>-1)
        {
          state.userIdentities[foundIndex] = payload;
        }else
        state.userIdentities.push(payload);

      }else
        state.userIdentities.push(payload);
    },
    setJwtToken(state,payload){
      state.jwtToken=payload
    },
    setMainUserGBGStatus:(state, payload)=>{
      state.mainUserGBGStatus= payload;
    },
    setAdditionalUserGBGStatus:(state, payload)=>{
      state.additionalUserGBGStatus= payload;
    },
    setAntispamStatus:(state,payload)=>{
      state.form.antiSpam=payload;
    },
    showCallback: (state, payload) => {
      state.form.showCallback = payload;
    }
  },
  actions: {
    setTabs: ({ commit }, payload) => {
      commit("setTabs", payload);
    },
    setCurrentActive: ({ commit }, payload) => {
      commit("setCurrentActive", payload);
    },
    setTotalTabs: ({ commit }, payload) => {
      commit("setTotalTabs", payload);
    },
    showHideMobileVerification: ({ commit }, payload) => {
      commit("showHideMobileVerification", payload);
    },
    twoFaMessage:({commit},payload)=>{  
      commit("twoFaMessage", payload);
    },
    setFinalStep: ({ commit }, payload) => {
      commit("setFinalStep", payload);
    },
    setMessageInfo: ({ commit }, payload) => {
      commit("setMessageInfo", payload);
    },
    setContactId: ({ commit }, payload) => {
      commit("setContactId", payload);
    },
    setMainContactId: ({ commit }, payload) => {
      commit("setMainContactId", payload);
    },
    setAdditionalContactId: ({ commit }, payload) => {
      commit("setAdditionalContactId", payload);
    },
    addUserIdentity: ({ commit }, payload) => {
      commit("addUserIdentity", payload);
    },
    setContactExist: ({ commit }, payload) => {
      commit("setContactExist", payload);
    },
    setHideNavigation: ({ commit }, payload) => {
      commit("setHideNavigation", payload);
    },
    setMobileVerified: ({ commit }, payload) => {
      commit("setMobileVerified", payload);
    },
    setGBGVerified: ({ commit }, payload) => {
      commit("setGBGVerified", payload);
    },
    isPrivateClient: ({ commit }, payload) => {
      commit("isPrivateClient", payload);
    },    
    setCountries: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/countryListing")
        .then((res) => {
          const countries = res.data.data;
          commit(
            "setCountries",
            countries.filter((c) => c.ShowOnSite)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setCountryCodes: ({ commit },payload) => {
          commit("setCountryCodes", payload);
    },
    setCurrencies: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/currencyListing")
        .then((res) => {
          const currencies = res.data.data;
          commit("setCurrencies", currencies);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setRfts: ({ commit }) => {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/client/rftListing?ClientType=Private"
        )
        .then((res) => {
          const rfts = res.data.data.sort((a, b) =>
            a.CodesId > b.CodesId ? 1 : -1
          );
          commit("setRfts", rfts);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setJwtToken: ({ commit }, payload) => {
      commit("setJwtToken", payload);
    },    
    setMainUserGBGStatus: ({commit},payload)=>{
      commit("setMainUserGBGStatus",payload);
    },
    setAdditionalUserGBGStatus: ({commit},payload)=>{
      commit("setAdditionalUserGBGStatus",payload);
    },
    setAntispamStatus:({commit},payload)=>{
      commit("setAntispamStatus",payload);
    } ,
    showCallback: ({ commit }, payload) => {
      commit("showCallback", payload);
    }
  },
  modules: {},
});
